import { StrictMode } from 'react';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { QueryProvider } from 'app/providers/QueryProvider';
import { RouterProvider } from 'app/providers/router/router-provider';
import 'app/styles/index.scss';

import GilroyBold from 'shared/assets/fonts/Gilroy-Bold.ttf';
import GilroyMedium from 'shared/assets/fonts/Gilroy-Medium.ttf';
import GilroyRegular from 'shared/assets/fonts/Gilroy-Regular.ttf';
import GilroySemiBold from 'shared/assets/fonts/Gilroy-SemiBold.ttf';
import MazzardMedium from 'shared/assets/fonts/Mazzard-Medium.ttf';
const theme = createTheme({
  typography: {
    fontFamily: 'Gilroy, sans-serif',
    fontSize: 18,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          @font-face {
            font-family: 'Gilroy';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: url(${GilroyRegular}) format('truetype');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
  
          }
          @font-face {
            font-family: 'Gilroy';
            font-style: normal;
            font-display: swap;
            font-weight: 500;
            src: url(${GilroyMedium}) format('truetype');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'Gilroy';
            font-style: normal;
            font-display: swap;
            font-weight: 600;
            src: url(${GilroySemiBold}) format('truetype');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'Gilroy';
            font-style: normal;
            font-display: swap;
            font-weight: 700;
            src: url(${GilroyBold}) format('truetype');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'Mazzard';
            font-style: normal;
            font-display: swap;
            font-weight: 500;
            src: url(${MazzardMedium}) format('truetype');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          body {
            background-color: #ECF3F6;
            color: #001317;
          }
        `,
    },
  },
});

export const App = () => (
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryProvider>
        <RouterProvider />
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>
);
